import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategorySection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="Topics"
          title="按栏目找你想看的热闹"
          desc="五个栏目对应五种不同类型的文化摩擦，从最日常的沟通习惯到最敏感的公共表达边界。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat, index) => {
            const count = articles.filter((item) => item.category === cat.slug).length;
            return (
              <Reveal key={cat.slug} delay={index * 70}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-400 hover:bg-primary-50"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{cat.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                  <span className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                    <span>{count} 篇观察</span>
                    <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}